import { actionTypesOfNonPodiatry } from 'reducer/actionType';
import { NonPodiatryOptionsType } from 'types/types';
import { painWorstOptions } from 'lib/commonOptions';

export const haveYouSeenOtherProviderOptions = {
  title: 'Have you seen any other providers for this?',
  subTitle: 'Choose one',
  options: ['Yes', 'No'],
};

export const nonPodiatryOptions: NonPodiatryOptionsType[] = [
  {
    name: actionTypesOfNonPodiatry.REASON_FOR_VISIT,
    title: 'Reason for visit',
    subTitle: 'Choose all that apply',
    options: [
      'Foot',
      'Ankle',
      'Calf',
      'Knee',
      'Thigh / Hamstring',
      'Hip',
      'Back',
      'Hand / Wrist',
      'Elbow',
      'Shoulder',
      'Neck',
      'Head',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.WHICH_SIDE,
    title: 'Which side?',
    subTitle: 'Choose one',
    options: ['Left', 'Right', 'Both'],
  },
  {
    name: actionTypesOfNonPodiatry.CONSISTENTLY_OR_OFF_PROBLEM,
    title: 'Consistently, or on and off?',
    subTitle: 'Choose one',
    options: ['Consistently', 'On and off'],
  },
  {
    name: actionTypesOfNonPodiatry.HOW_DID_IT_START,
    title: 'How did it start?',
    subTitle: 'Choose one',
    options: [
      'Accident at work',
      'Slip and fall',
      'Car accident',
      'Repetitive stress / exercise',
      'Diabetes',
      'Chronic condition',
      'Unknown',
      'Other',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_ARE_YOUR_SYMPTOMS,
    title: 'What are your symptoms?',
    subTitle: 'Choose all that apply',
    options: [
      'Pain',
      'Numbness',
      'Swelling',
      'Stiffness',
      'Open Wound',
      'Discoloration',
      'Drainage',
      'Flaking',
      'Nail thickening',
      'Other',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TYPE_OF_PAIN,
    title: 'What type of pain?',
    subTitle: 'Choose all that apply',
    options: [
      'Throbbing',
      'Radiating',
      'Stabbing',
      'Pins & needles',
      'Aching',
      'Stinging',
      'Other',
      'None',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.PAIN_WORST,
    title: 'When is the pain worst?',
    subTitle: 'Choose all that apply',
    options: painWorstOptions,
  },
  {
    name: actionTypesOfNonPodiatry.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER,
    title:
      'Which of the following can you no longer do because of your condition?',
    subTitle: 'Choose all that apply',
    options: [
      'Groom yourself',
      'Get in a car',
      'Go to work',
      'Walk more than 200 feet without stopping',
      'Chores around the house',
      'Not applicable',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.TREATMENTS_TRIED_HOME,
    title: 'What treatments have you tried at home?',
    subTitle: 'Choose all that apply',
    options: [
      'Soaking',
      'Over the counter pain reliever (e.g. Tylenol, Motrin)',
      'Topical creams, gels, or patches',
      'Ice',
      'Different shoes',
      'Shoe inserts',
      'Heating pads',
      'Rest',
      'Elevation',
      'Other',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TREATMENTS_RECOMMENDED_PRE_PROVIDER,
    title: 'What treatments were recommended by your previous provider?',
    subTitle: 'Choose all that apply',
    options: [
      'Orthotic / Shoe insert',
      'Injection',
      'Physical therapy',
      'Surgery',
      'X-Ray',
      'MRI',
      'CAT scan',
      '(Oral) prescription medication',
      '(Topical) prescription medication',
    ],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TREATMENTS_WERE_HELPFUL,
    title: 'Which treatments were helpful?',
    subTitle: 'Choose all that apply',
    options: [
      'Injection',
      'Physical therapy',
      'Over the counter pain reliever (e.g. Tylenol, Motrin)',
      'Different shoes',
      'Rest',
    ],
  },
];
